export default __webpack_public_path__ + "static/media/pic11.709054c7.jpg";